import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ActiveList } from "../../../../Constant";
import { ACTIVE_DATA, ACTIVE_LIST } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const ActiveLists = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={ActiveList} span={ACTIVE_DATA} />
        <CardBody>
          <UL>
            <LI className="active bg-warning-light"><i className="icofont icofont-arrow-right"> </i>UI Kits</LI>
            {ACTIVE_LIST.map((item, index) => (
            <LI key={index}><i className="icofont icofont-arrow-right"></i>{item}</LI>
          ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ActiveLists;
